import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { Link } from 'react-router-dom';
import { getMediaUrl, DEFAULT_MEDIA_URL, withImageFallback } from '../../utils/imageUtils';
import 'swiper/css';
import 'swiper/css/pagination';

const EditorsChoiceWidget = ({ posts }) => {
  if (!posts || posts.length === 0) {
    return null; // No muestra nada si no hay posts
  }

  return (
    <div className="bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-700 rounded-lg w-auto shadow-md mb-6">
      <div className="relative">
        <Swiper
          // 2. Añade Autoplay a la lista de módulos
          modules={[Navigation, Pagination, Autoplay]}
          navigation
          pagination={{ clickable: true }}
          loop={posts.length > 1}
          // 3. Configura el autoplay
          autoplay={{
            delay: 6000, // Cambia cada 4 segundos
            disableOnInteraction: false,
          }}
          className="editors-choice-swiper" // Clase para estilos personalizados si es necesario
        >
          {posts.map((post) => (
            <SwiperSlide key={post._id}>
              <div className="relative w-full h-64 group">      
                <h3 className="font-bold w-full text-white text-xs center mt-2 mb-2 left-0 absolute pb-2">
                  Elección del Editor
                </h3>
                <img
                  src={getMediaUrl(post.images?.[0], DEFAULT_MEDIA_URL)}
                  alt={post.title}
                  className="w-full h-full object-cover rounded-lg"
                  onError={(event) => withImageFallback(event, DEFAULT_MEDIA_URL)}
                />
                <div className="absolute inset-0 bg-gradient-to-tl from-black/60 to-transparent rounded-lg"></div>
                <div className="absolute bottom-0 left-0 p-4 text-white">
                  <Link
                    to={`/news/${post.category?.slug}`}
                    className="px-4 py-1 bg-blue-600 text-white text-xs font-semibold rounded-md"
                  >
                    {post.category?.name}
                  </Link>
                  <h4 className="text-md font-bold mt-2">
                    <Link to={`/post/${post._id}`}>{post.title}</Link>
                  </h4>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default EditorsChoiceWidget;
